/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{create as r}from"../../../../core/libs/gl-matrix-2/factories/vec3f64.js";class t{constructor(){this.up=r(),this.right=r()}}export{t as PathFrame2D};
